import React, { useState, useEffect, useRef } from "react";

function InfoPage() {

    return (
        <div className="pageContainer">
            <h1>帳號資訊</h1>
        </div>
    );
}
export default InfoPage;